import React          from 'react';
import box_0          from '../images/box_0.png';
import box_1          from '../images/box_1.png';
import box_2          from '../images/box_2.png';
import box_3          from '../images/box_3.png';
import box_4          from '../images/box_4.png';
import box_5          from '../images/box_5.png';
import box_6          from '../images/box_6.png';
import box_7          from '../images/box_7.png';
import box_8          from '../images/box_8.png';
import box_9          from '../images/box_9.png';
import box_10         from '../images/box_10.png';
import closedBox      from '../images/closedBox.png';

import { makeStyles } from '@material-ui/core/styles';

const arr = [box_0, box_1, box_2, box_3, box_4, box_5, box_6, box_7, box_8, box_9, box_10];

const useStyles = makeStyles(() => ({
    root: {
      display:            'flex',
      alignItems:         'center',
      flexFlow:           'column',
    },
    img: {
      position:           'absolute',
      backgroundPosition: 'bottom',
      backgroundSize:     'contain',
      backgroundRepeat:   'no-repeat',
      transition:         'background 0.3s'
    },
    img2: {
      position:           'absolute',
      backgroundPosition: 'bottom',
      backgroundSize:     'contain',
      backgroundRepeat:   'no-repeat',
      backgroundImage:    `url(${ closedBox })`,
      transition:         'opacity 0.6s'
    },
    
}))

type EggBoxProps = {
    wideScreen:  boolean;
    value:       number;
    imgSize?:    number[]
    closeAtTen?: boolean;
    onClick?:    () => void;
}

const EggBox: React.FC<EggBoxProps> = ({ wideScreen, value, imgSize, closeAtTen, onClick }) => {

  const classes = useStyles();

  const [imagesrc, setImageSrc]           = React.useState(arr[value])
  const [showClosedBox, setShowClosedBox] = React.useState(false)

   React.useEffect(() => {
       setImageSrc(arr[value])
   },[value])
  

   React.useEffect(() => {

    if (closeAtTen && value === 10) {
      setTimeout(() => {
        setShowClosedBox(true)
      },500)
    }
    else {
      setShowClosedBox(false)
    }
  },[value, closeAtTen])  


  const rootStyle = React.useMemo(() => {
      return{
           width:  imgSize ? imgSize[0] : wideScreen ? 250 : 150,
           height: imgSize ? imgSize[1] : wideScreen ? 90 : 40,
        }
  },[wideScreen, imgSize])
  

  return (
     <div 
        className    = { classes.root }
        style        = { rootStyle }
        onMouseDown  = { onClick }
        onTouchStart = { onClick }
     >
       <div
          className = { classes.img }
          style     = {{ 
               width:           imgSize ? imgSize[0] : wideScreen ? 250 : 150,
               height:          imgSize ? imgSize[1] : wideScreen ? 90 : 40,
               backgroundImage: `url(${ imagesrc })`,
           }}
       /> 
       <div
          className = { classes.img2 }
          style     = {{ 
               width:    imgSize ? imgSize[0] : wideScreen ? 250 : 150,
               height:   imgSize ? imgSize[1] : wideScreen ? 90 : 40,
               opacity:  showClosedBox ? 1 : 0
           }}
       /> 
    </div>
  );
}



export default EggBox;








